module.exports = __webpack_public_path__ + "img/loads.1a5a0689.svg";